import { jsx as _jsx } from "react/jsx-runtime";
import { Waiting } from '../Waiting/Waiting.js';
export const AwaitingOAuthStep = () => {
    return _jsx(Waiting, { heading: "Complete Login", subheading: "Follow the prompts presented by your browser." });
};
